import { useContext, useEffect, useState } from "react";
import { MdArrowForward, MdCalendarToday } from "react-icons/md";
import { AppContext } from "../App";
import { CDN_URL, getInlineLoader } from "../Helpers";
import fallbackImage from "../assets/banner-removebg-preview.png";

function formatProductDate(timestamp) {
  if (!timestamp) {
    return "Recently added";
  }

  const date = String(timestamp).length <= 10
    ? new Date(Number(timestamp) * 1000)
    : new Date(timestamp);

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
}

export default function HomeProductsSection() {
  const appContext = useContext(AppContext);
  const [latestProducts, setLatestProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  function goToProducts() {
    appContext.navTo({
      item: "products",
    });
  }

  function goToProductCatalog(product) {
    appContext.navTo({
      item: "products",
      subItem: "catalog",
      extraItem: product.uuid,
    });
  }

  useEffect(() => {
    let mounted = true;

    async function loadProducts() {
      setLoading(true);
      const products = await appContext.getAllProducts({ limit: 3 });
      if (mounted) {
        setLatestProducts(products);
        setLoading(false);
      }
    }

    loadProducts();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <section className="MainBodySection home-products-section">
      <div className="container">
        <div className="home-section-head home-products-head">
          <div data-aos="fade-up">
            <p className="home-banner-kicker">Newest Products</p>
            <h2 className="home-service-title font-bold">Fresh From Our Product Desk</h2>
          </div>

          <button
            type="button"
            className="home-section-link"
            onClick={goToProducts}
            data-aos="fade-left"
          >
            View All Products
            <MdArrowForward size={20} />
          </button>
        </div>

        {loading ? (
          <div className="mSupportLoading" style={{ minHeight: 260 }}>
            {getInlineLoader()}
          </div>
        ) : latestProducts.length > 0 ? (
          <div className="home-products-grid">
            {latestProducts.map((product, index) => (
              <article
                className="home-products-card"
                key={product.uuid || product.id}
                data-aos="fade-up"
                data-aos-delay={index * 80}
                role="button"
                tabIndex={0}
                onClick={() => goToProductCatalog(product)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    goToProductCatalog(product);
                  }
                }}
              >
                <div className="home-products-card-media">
                  <img
                    src={product.photo ? CDN_URL + product.photo : fallbackImage}
                    alt={product.title || "Esmeriser product"}
                  />
                </div>

                <div className="home-products-card-body">
                  <span className="home-products-card-date">
                    <MdCalendarToday size={15} />
                    {formatProductDate(product.dateCreated || product.date)}
                  </span>
                  <h3 className="font-bold">{product.title || "Esmeriser Product"}</h3>
                  <p>{product.description || "Explore this branded product from Esmeriser."}</p>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="home-empty-state">
            <h3 className="font-bold">Products are coming soon.</h3>
            <p>New product records from the admin panel will appear here.</p>
          </div>
        )}
      </div>
    </section>
  );
}
